import styled, { css } from 'styled-components';

const ALIGN = { top: 'flex-start', left: 'flex-start', right: 'flex-end', center: 'center', bottom: 'flex-end' };

const Width = css`
  flex-basis: ${(props) => props.$width};
`;

const Height = css`
  height: ${(props) => props.$height};
`;

const HorizontalAlign = css`
  justify-content: ${(props) => ALIGN[props.$hAlign] || 'stretch'};
`;

const VerticalAlign = css`
  align-items: ${(props) => ALIGN[props.$vAlign] || 'stretch'};
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  ${(props) => (props.$shrink ? `flex-shrink: ${props.$shrink};` : '')};
  ${(props) => (props.$wrap ? `flex-wrap: ${props.$wrap};` : '')};

  ${(props) => (props.$width ? Width : '')};
  ${(props) => (props.$height ? Height : '')};

  ${(props) => (props.$hAlign ? HorizontalAlign : '')};
  ${(props) => (props.$vAlign ? VerticalAlign : '')};

  ${(props) => (props.$padding ? `padding: ${props.$padding};` : '')};
  ${(props) => (props.$margin ? `margin: ${props.$margin};` : '')};
  ${(props) => (props.$zIndex ? `z-index: ${props.$zIndex};` : '')};
  ${(props) => (props.$position ? `position: ${props.$position};` : '')};
  ${(props) => (props.$overflow ? `overflow: ${props.$overflow};` : '')};
  ${(props) => (props.$border ? `border: ${props.$border};` : '')};
  ${(props) => (props.$borderStyle ? `border-style: ${props.$borderStyle};` : '')};
  ${(props) => (props.$wordbreak ? `word-break: ${props.$wordbreak};` : '')};
  ${(props) => (props.$maxWidth ? `max-width: ${props.$maxWidth};` : '')};
  ${(props) => (props.$maxHeight ? `max-height: ${props.$maxHeight};` : '')};
  ${(props) => (props.$transition ? `transition: ${props.$transition};` : '')};
  ${(props) => (props.$cursor ? `cursor: ${props.$cursor};` : '')};
  ${(props) => (props.$background ? `background: ${props.$background};` : '')};
  ${(props) => (props.$left ? `left: ${props.$left};` : '')};
  ${(props) => (props.$top ? `top: ${props.$top};` : '')};
`;

export default Row;
